import { request } from '@koi-design/vix-tools';
import {
  type CopilotValue1,
  type CopilotValue2,
  type CopilotValue3,
  type CopilotValue4,
  type CopilotValue17,
  type CopilotValue8,
  type CopilotValue9,
  type CopilotValue10,
  type CopilotValue11,
  type NeedWaitResponse,
  type CopilotValue16,
  type CopilotValue22
} from '@/stores/types/copilotValue';
import { prefixApi } from './urls';
import { QryCopilotDialog, CopilotHistoryInfo, RecommendHistoryInfo } from './types';

// 获取Copilot值数据
export const getCopilotValueApi = data =>
  request({
    url: `${prefixApi}/copilot/getValue`,
    method: 'post',
    headers: {
      merchantId: '2025070802'
    },
    data
  });

// 获取Copilot其他值数据
export const getCopilotOtherValueApi = data =>
  request({
    url: `${prefixApi}/copilot/getOtherValue`,
    method: 'post',
    headers: {
      merchantId: '2025070802'
    },
    data
  });

// 获取Copilot值数据
export const qryCopilotValueApi = data =>
  request({
    url: `${prefixApi}/copilot/qryCopilotValue`,
    method: 'post',
    data
  });

/**
 *
 * @param {*} data
 * reqType: 请求类型
 *   1, 客户画像agent请求结果
 *   2, 客户画像额外信息请求结果
 *   3, 持仓诊断agent请求结果
 *   4, 资产配置agent请求结果
 *   8, 投顾洞察-产品推荐agent请求
 *   9, 投顾洞察-产品对比agent请求
 *   10, 投顾洞察-产品解读agent请求
 *   11, 投顾洞察-市场解读agent请求
 *   16, 趋势走向
 *   17, 市场分析
 * @returns
 */

type CopilotResponseMap = {
  1: CopilotValue1;
  2: CopilotValue2;
  3: CopilotValue3;
  4: CopilotValue4;
  8: CopilotValue8;
  9: CopilotValue9;
  10: CopilotValue10;
  11: CopilotValue11;
  16: CopilotValue16;
  17: CopilotValue17;
  22: CopilotValue22;
};

export function getCopilotValueByTaskIdApi<T extends keyof CopilotResponseMap>(
  data: { reqType: T } & Record<string, any>
): Promise<CopilotResponseMap[T] | NeedWaitResponse> {
  return request({
    url: `${prefixApi}/copilot/getCopilotValueByTaskId`,
    method: 'post',
    data
  });
}

// 获取Copilot对话数据
export const qryCopilotDialogApi = data =>
  request<{ data: QryCopilotDialog }>({
    url: `${prefixApi}/copilot/qryCopilotDialog`,
    method: 'post',
    catchAll: true,
    data
  });

// 获取资产配置历史数据
export const qryCopilotHistoryInsightsApi = data =>
  request({
    url: `${prefixApi}/copilot/getCopilotAssetHistoryInfo`,
    method: 'post',
    data
  });

// 获取投顾洞察历史数据
export const getCopilotHistoryInfoApi = data =>
  request<CopilotHistoryInfo>({
    url: `${prefixApi}/copilot/getCopilotHistoryInfo`,
    method: 'post',
    data
  });

// 获取Copilot新闻数据 (美股 2 ，新闻 1  沪深 3)
export const qryCopilotNewsApi = data =>
  request({
    url: `${prefixApi}/copilot/qryCopilotOnTimeData`,
    method: 'get',
    data
  });

// 获取临时媒体 MediaId
export const getTempMediaUrlApi = data =>
  request({
    url: `${prefixApi}/copilot/getTempMediaUrl`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  });

// 查询红点提示
export const getRedPointStatusApi = data =>
  request({
    url: `${prefixApi}/copilot/getRedPointStatus`,
    method: 'get',
    data
  });

// 清除红点提示
export const clearRedPointStatusApi = data =>
  request({
    url: `${prefixApi}/copilot/clearRedPointStatus`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  });

// 历史推荐记录
export const getCopilotRecommendHistoryInfoApi = (data: { externalUserId: string }) =>
  request<RecommendHistoryInfo>({
    url: `${prefixApi}/copilot/getCopilotRecommendHistoryInfo`,
    method: 'post',
    data
  });

//保存优化推荐Agent数据接口
export const saveRecommendAgentDataApi = data =>
  request({
    url: `${prefixApi}/copilot/saveRecommendAgentData`,
    method: 'post',
    data
  });
